import { render, staticRenderFns } from "./SettingsTab.vue?vue&type=template&id=4310e6c8&"
import script from "./SettingsTab.vue?vue&type=script&lang=js&"
export * from "./SettingsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports